"use strict";

exports.__esModule = true;
exports.LogbookController = void 0;
var _react = require("react");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _API = require("../../API");
var _constants = require("../constants");
var _User = require("../../User");
var _Time = require("../../Time");
var _TicketingContext = require("../../Ticketing/TicketingContext");
var _Auth = require("../../Auth");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Utils = require("../../../Utils");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _timeDefinitions = require("../../timeDefinitions");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _LogbookController;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var getCommentCreator = function getCommentCreator(creator, users) {
  var user = users ? users.getUserByName(creator) : null;
  return user ? (0, _Utils.formatUserName)(user) : _constants.INTERNAL_USER;
};
var getInterval = function getInterval(location, time, interval) {
  var _time$currentWorkday;
  if (location.pathname.split("/")[1] === "operator-panels" && time != null && (_time$currentWorkday = time.currentWorkday) != null && _time$currentWorkday.interval) {
    return {
      startMillis: time.currentWorkday.interval.endMillis - (0, _timeDefinitions.getDaysMillis)(30),
      endMillis: time.currentWorkday.interval.endMillis
    };
  }
  return interval;
};
var LogbookController = exports.LogbookController = (_dec = _API.RestAPIContext.withContext, _dec2 = _User.UserListContext.withContext, _dec3 = _Auth.AuthContext.withContext, _dec4 = _TicketingContext.TicketingContext.withContext, _dec5 = _DeviceListContext.DeviceListContext.withContext, _dec6 = _DataAccessorContext.DataAccessorContext.withContext, _dec7 = _Time.TimeContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = (0, _reactRouterCompat.withRouter)(_class = (_LogbookController = /*#__PURE__*/function (_Component) {
  function LogbookController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: false,
      showNewTicket: false,
      showNewComment: false,
      showFilterPanel: false,
      device: _this.props.device,
      interval: _this.props.interval,
      ticketTypes: [],
      nonDeviceTicketTypes: [],
      filteredTicketTypes: [],
      searchTerm: "",
      selectedItemTypes: [_constants.LOGBOOK_COMMENT, _constants.LOGBOOK_TICKET],
      logbookItems: [],
      filteredLogbookItems: [],
      watcherRules: [],
      toggleFilterPanel: function toggleFilterPanel() {
        _this.setState({
          showFilterPanel: !_this.state.showFilterPanel
        });
      },
      closeEventPanels: function closeEventPanels() {
        _this.setState({
          showNewTicket: false,
          showNewComment: false
        });
      },
      toggleAddTicketPanel: function toggleAddTicketPanel() {
        _this.setState({
          showNewTicket: !_this.state.showNewTicket
        });
      },
      toggleAddCommentPanel: function toggleAddCommentPanel() {
        _this.setState({
          showNewComment: !_this.state.showNewComment
        });
      },
      assignTicket: function assignTicket(ticketId) {
        var _this$props = _this.props,
          username = _this$props.auth.username,
          users = _this$props.users;
        var user = users.getUserByName(username);
        var userId = user && user.id;
        if (userId) {
          var updateQuery = {
            assigneeId: userId
          };
          return _this.state.updateTicketDetails(ticketId, updateQuery);
        }
      },
      // eslint-disable-next-line react/no-unused-state
      getLogbookData: function () {
        var _getLogbookData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var _this$props2, time, location, interval, definedInterval, commentQuery, ticketQuery, _yield$Promise$all, _yield$Promise$all$, ticketList, watcherRulesList, filteredTicketTypes, ticketTypes, commentsResponse, comments, logbookArray, sortedLogbookArray, nonDeviceTicketTypes, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _this.setState({
                  loading: true
                });
                _this$props2 = _this.props, time = _this$props2.time, location = _this$props2.location, interval = _this$props2.interval;
                definedInterval = getInterval(location, time, interval);
                commentQuery = {
                  devices: [_this.props.device.uuid],
                  start: new Date(definedInterval.startMillis).toISOString(),
                  end: new Date(definedInterval.endMillis).toISOString()
                };
                ticketQuery = {
                  deviceUuids: _this.props.device.uuid,
                  overlapping: (0, _Utils.formatIntervalForTickets)(definedInterval)
                };
                _context.p = 1;
                _context.n = 2;
                return Promise.all([_this.props.ticketing.fetchTickets(ticketQuery), _this.props.dataAccessor.getComments(commentQuery)]);
              case 2:
                _yield$Promise$all = _context.v;
                _yield$Promise$all$ = _yield$Promise$all[0];
                ticketList = _yield$Promise$all$.ticketList;
                watcherRulesList = _yield$Promise$all$.watcherRulesList;
                filteredTicketTypes = _yield$Promise$all$.filteredTicketTypes;
                ticketTypes = _yield$Promise$all$.ticketTypes;
                commentsResponse = _yield$Promise$all[1];
                comments = commentsResponse.length > 0 ? commentsResponse.map(function (c) {
                  return Object.assign({}, c, {
                    type: _constants.LOGBOOK_COMMENT,
                    devices: [_this.props.devices.find(function (d) {
                      return d.uuid === c.deviceUuid;
                    })] || [],
                    creator: getCommentCreator(c.author, _this.props.users),
                    created: c.interval.startMillis
                  });
                }) : [];
                logbookArray = [].concat(ticketList, comments);
                sortedLogbookArray = (0, _Utils.sortBy)(logbookArray, "created").reverse();
                nonDeviceTicketTypes = ticketTypes.filter(function (tt) {
                  return !filteredTicketTypes.includes(tt);
                }).filter(function (tt) {
                  return tt.enabled;
                });
                _this.setState({
                  filteredTicketTypes: filteredTicketTypes.filter(function (ftt) {
                    return ftt.enabled;
                  }),
                  ticketTypes: ticketTypes,
                  watcherRules: watcherRulesList,
                  nonDeviceTicketTypes: nonDeviceTicketTypes,
                  logbookItems: sortedLogbookArray,
                  filteredLogbookItems: (0, _Utils.filterByType)((0, _Utils.filterBy)(sortedLogbookArray, _this.state.searchTerm), _this.state.selectedItemTypes),
                  loading: false
                });
                _context.n = 4;
                break;
              case 3:
                _context.p = 3;
                _t = _context.v;
                _this.setState({
                  logbookItems: [],
                  filteredLogbookItems: [],
                  loading: false
                });
              case 4:
                return _context.a(2);
            }
          }, _callee, null, [[1, 3]]);
        }));
        function getLogbookData() {
          return _getLogbookData.apply(this, arguments);
        }
        return getLogbookData;
      }(),
      createNewComment: function () {
        var _createNewComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(newComment) {
          var added, logbookReset;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return _this.props.ticketing.createNewComment(newComment);
              case 1:
                added = _context2.v;
                logbookReset = document.getElementById("logbook-reset-button-" + _this.state.device.uuid);
                if (logbookReset) {
                  logbookReset.click();
                }
                return _context2.a(2, added);
            }
          }, _callee2);
        }));
        function createNewComment(_x) {
          return _createNewComment.apply(this, arguments);
        }
        return createNewComment;
      }(),
      updateComment: function () {
        var _updateComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(comment) {
          var updated;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _context3.n = 1;
                return _this.props.ticketing.updateComment(comment);
              case 1:
                updated = _context3.v;
                _context3.n = 2;
                return _this.state.getLogbookData();
              case 2:
                return _context3.a(2, updated);
            }
          }, _callee3);
        }));
        function updateComment(_x2) {
          return _updateComment.apply(this, arguments);
        }
        return updateComment;
      }(),
      deleteComment: function () {
        var _deleteComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(comment) {
          var updated;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _context4.n = 1;
                return _this.props.ticketing.deleteComment(comment);
              case 1:
                updated = _context4.v;
                _context4.n = 2;
                return _this.state.getLogbookData();
              case 2:
                return _context4.a(2, updated);
            }
          }, _callee4);
        }));
        function deleteComment(_x3) {
          return _deleteComment.apply(this, arguments);
        }
        return deleteComment;
      }(),
      createNewTicket: function createNewTicket(ticketQuery) {
        return _this.props.ticketing.createNewTicket(ticketQuery);
      },
      getTicketDetails: function () {
        var _getTicketDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(ticketId) {
          var _t2;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.p = _context5.n) {
              case 0:
                _context5.p = 0;
                _context5.n = 1;
                return _this.props.ticketing.getTicketDetails(ticketId);
              case 1:
                return _context5.a(2, _context5.v);
              case 2:
                _context5.p = 2;
                _t2 = _context5.v;
                console.error(_t2);
              case 3:
                return _context5.a(2);
            }
          }, _callee5, null, [[0, 2]]);
        }));
        function getTicketDetails(_x4) {
          return _getTicketDetails.apply(this, arguments);
        }
        return getTicketDetails;
      }(),
      updateTicketDetails: function () {
        var _updateTicketDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(ticketId, updateQuery) {
          var _t3;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.p = _context6.n) {
              case 0:
                _context6.p = 0;
                _context6.n = 1;
                return _this.props.ticketing.updateTicketDetails(ticketId, updateQuery);
              case 1:
                return _context6.a(2, _context6.v);
              case 2:
                _context6.p = 2;
                _t3 = _context6.v;
                console.error(_t3);
              case 3:
                return _context6.a(2);
            }
          }, _callee6, null, [[0, 2]]);
        }));
        function updateTicketDetails(_x5, _x6) {
          return _updateTicketDetails.apply(this, arguments);
        }
        return updateTicketDetails;
      }(),
      createTicketComment: function () {
        var _createTicketComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(ticketId, comment) {
          var _t4;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.p = _context7.n) {
              case 0:
                _context7.p = 0;
                _context7.n = 1;
                return _this.props.ticketing.createTicketComment(ticketId, comment);
              case 1:
                return _context7.a(2, _context7.v);
              case 2:
                _context7.p = 2;
                _t4 = _context7.v;
                console.error(_t4);
              case 3:
                return _context7.a(2);
            }
          }, _callee7, null, [[0, 2]]);
        }));
        function createTicketComment(_x7, _x8) {
          return _createTicketComment.apply(this, arguments);
        }
        return createTicketComment;
      }(),
      setSelectedItemTypes: function setSelectedItemTypes(itemType) {
        var newItemTypes = [];
        if (_this.state.selectedItemTypes.includes(itemType)) {
          newItemTypes = _this.state.selectedItemTypes.filter(function (item) {
            return item !== itemType;
          });
        } else {
          newItemTypes = [].concat(_this.state.selectedItemTypes, itemType);
        }
        _this.setState({
          selectedItemTypes: newItemTypes,
          filteredLogbookItems: (0, _Utils.filterByType)((0, _Utils.filterBy)(_this.state.logbookItems, _this.state.searchTerm), newItemTypes)
        });
      },
      filterLogbookItems: function filterLogbookItems(searchTerm) {
        _this.setState({
          searchTerm: searchTerm,
          filteredLogbookItems: (0, _Utils.filterByType)((0, _Utils.filterBy)(_this.state.logbookItems, searchTerm), _this.state.selectedItemTypes)
        });
      }
    };
    return _this;
  }
  _inheritsLoose(LogbookController, _Component);
  var _proto = LogbookController.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.state.getLogbookData();
  };
  LogbookController.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var device = _ref.device,
      interval = _ref.interval;
    if ((0, _reactFastCompare["default"])(device, prevState.device) && (0, _reactFastCompare["default"])(interval, prevState.interval)) {
      return null;
    }
    return {
      logbookItems: [],
      filteredLogbookItems: [],
      device: device,
      interval: interval
    };
  };
  _proto.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var device = prevState.device,
      interval = prevState.interval;
    if ((0, _reactFastCompare["default"])(device, this.state.device) && (0, _reactFastCompare["default"])(interval, this.state.interval)) {
      return null;
    }
    this.state.getLogbookData();
  };
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return LogbookController;
}(_react.Component), _LogbookController.defaultProps = {
  api: undefined,
  dataAccessor: undefined,
  users: undefined,
  devices: undefined,
  ticketing: undefined
}, _LogbookController)) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
LogbookController.displayName = "LogbookController";